import { useNavigate } from "react-router-dom";

export default function LatestBook() {
  const navigate = useNavigate();

  return (
    <section
      className="
        bg-black text-white
        px-5 py-8
        md:p-12
        grid grid-cols-1 md:grid-cols-2
        gap-8 md:gap-10
        items-start
      "
    >
      {/* IMAGES */}
      <div>
        <div className="flex items-center gap-3">
          <h3 className="text-xs md:text-sm uppercase tracking-wide text-[#D07728] whitespace-nowrap">
            Latest Book
          </h3>

          <div className="h-px flex-1 max-w-32 bg-[#D07728]/60" />
        </div>

        <div className="grid grid-cols-2 gap-2 md:gap-4 mt-4">
          <img
            src="/images/decolonizingmission.png"
            alt="Decolonizing Mission"
            loading="lazy"
            decoding="async"
            className="w-full aspect-[4/5] object-cover"
          />

          <img
            src="/images/decolonizinglaunch.png"
            alt="Decolonizing Mission's Launch"
            loading="lazy"
            decoding="async"
            className="w-full aspect-[4/5] object-cover"
          />

          <img
            src="/images/tenoutstandingbooks.png"
            alt="Ten Outstanding Books in Mission Studies of 2025"
            loading="lazy"
            decoding="async"
            className="col-span-2 w-full aspect-[3/2] object-cover"
          />
        </div>
      </div>

      {/* TEXT */}
      <div>
        <h2 className="text-2xl md:text-4xl mb-3 md:mb-4">
          Decolonizing
          <span className="text-[#D07728]"> Mission</span>
        </h2>

        <p className="text-gray-300 mb-5 md:mb-6 text-base md:text-lg text-justify leading-relaxed">
          For 500 years, the idea of God's mission has been synonymous with
          Western civilisation's expansion. In this landmark work, Harvey
          Kwiyani traces the history of Christian mission alongside the history
          of empire and imagines what mission without imperialism looks like.
          <br />
          <br />
          An invitation to realign our missional methods with God's, not
          empire's.
        </p>

        {/* AWARD */}
        <div
          className="
            border border-l-4 border-[#D07728]
            bg-[#D0772815]
            px-4 py-4
            md:p-5
            mb-6 mt-4
            flex items-start
            gap-3 md:gap-4
          "
        >
          <div className="text-[#D07728] text-xl md:text-2xl leading-none mt-1 shrink-0">
            ★
          </div>

          <div>
            <p className="mb-2 text-[#D07728] tracking-wide text-xs md:text-sm font-medium">
              AWARD
            </p>

            <h3 className="mb-3 text-white text-base md:text-lg leading-snug">
              One of Ten Outstanding Books in Mission Studies, World
              Christianity and Intercultural Theology for 2025
            </h3>

            <p className="text-gray-300 text-sm md:text-base text-justify leading-relaxed">
              Selected among the ten outstanding books in{" "}
              <em>
                Mission Studies, World Christianity &amp; Intercultural Theology
              </em>{" "}
              for 2025 by the International Bulletin of Mission Research - a
              distinction honouring works of exceptional scholarship and
              enduring significance in the global church.
            </p>
          </div>
        </div>

        {/* BUTTONS */}
        <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
          <button
            onClick={() =>
              window.location.href =
                "https://www.amazon.co.uk/Decolonising-Mission-Harvey-C-Kwiyani/dp/0334063191"
            }
            className="
              bg-[#D07728]
              px-3 py-2
              md:px-4
              text-xs md:text-sm
              whitespace-nowrap
            "
          >
            BUY ON AMAZON
          </button>

          <button
            onClick={() =>
              window.location.href =
                "https://scmpress.hymnsam.co.uk/books/9780334063193/decolonizing-mission"
            }
            className="
              border
              px-3 py-2
              md:px-4
              text-xs md:text-sm
              whitespace-nowrap
            "
          >
            BUY ON SCM
          </button>

          <button
            onClick={() => navigate("/order-decolonizing-mission")}
            className="
              border
              px-3 py-2
              md:px-4
              text-xs md:text-sm
              whitespace-nowrap
            "
          >
            BUY IN KENYA
          </button>
        </div>
      </div>
    </section>
  );
}